// extracted by mini-css-extract-plugin
export var divider = "_tj-0";
export var systemMessage = "_tj-1";